var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"wobble-heart center-me "},[_c('i',{staticClass:"fas fa-heart animate__animated animate__wobble animate__infinite"})])}]

export { render, staticRenderFns }